let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("O3OZ0"), load("jXx9i"), load("9wxKg"), load("9ftJe"), load("jjWia")]).then(() => parcelRequire('liyuV'));